// Componente per mostrare i valori già verificati (in forma di tabella)
import React from 'react';

// Etichette descrittive per i campi
const LABELS = {
    cod_bolla: 'Codice Bolla',
    num_bolla: 'Numero Bolla',
    data_bolla: 'Data Bolla',
    rag_soc: 'Ragione Sociale',
    cod_pers: 'Cod. Cliente',
    targa: 'Targa',
    mittente: 'Mittente',
    rag_soc_vettore: 'Vettore',
    cod_vettore: 'Cod. Vettore',
    vett_ns: 'Vett. a carico nostro',
    mezzo_vettore: 'Mezzo Vettore',
    rag_soc_conducente: 'Conducente',
    conducente: 'Cod. Conducente',
    trasporto_carico_nostro: 'Trasp. carico nostro',
    cod_commessa: 'Commessa',
    data_inizio: 'Data Inizio',
    cod_artic: 'Cod. Articolo',
    unita: 'Unità',
    destinazione: 'Destinazione',
    id_dest: 'Cod. Destinazione',
    destinazione_pattern: 'Pattern Dest.',
    lordo: 'Lordo',
    tara: 'Tara',
    pesospec: 'Peso Specifico',
    num_silos: 'Num. Silos',
    temperatura: 'Temperatura',
    cig: 'CIG',
    cup: 'CUP',
    stampante: 'Stampante',
    stamparescontrino: 'Stampa Scontrino',
    modalita_coupon: 'Coupon di carico',
    cellulare: 'Cellulare conducente',
    dtara: 'Correzione tara',
    dlordo: 'Correzione lordo'
};

// Campi da non mostrare (interni)
const HIDDEN_FIELDS = ['commessa_trasporti_data_inizio'];

// Formatta il valore per la visualizzazione
function formatValue(key, value) {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'boolean') return value ? 'Sì' : 'No';
    if (key === 'data_bolla') {
        const date = new Date(value);
        return date.toLocaleString('it-IT');
    }
    if (key === 'data_inizio') {
        const date = new Date(value);
        return date.toLocaleDateString('it-IT');
    }
    return String(value);
}

export function ValoriVerificati({ valori }) {
    if (!valori || Object.keys(valori).length === 0) {
        return null;
    }

    const entries = Object.entries(valori)
        .filter(([key]) => !HIDDEN_FIELDS.includes(key))
        .sort((a, b) => {
            const labelA = LABELS[a[0]] || a[0];
            const labelB = LABELS[b[0]] || b[0];
            return labelA.localeCompare(labelB, 'it');
        });

    if (entries.length === 0) return null;

    return (
        <div className="mt-4">
            <small className="text-muted"><strong>Valori già verificati:</strong></small>
            <table className="table table-sm table-bordered mt-1" style={{ fontSize: '0.85rem' }}>
                <tbody>
                    {entries.map(([key, value]) => (
                        <tr key={key}>
                            <th className="bg-light" style={{ width: '40%' }}>{LABELS[key] || key}</th>
                            <td>{formatValue(key, value)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
